<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" :limit="limit" :setLimit="setLimit" 
        :page="page" :setPage="setPage" :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" addUrl="User/Add" :goDetail="goDetail" />

        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";
    import jwt_decode from "jwt-decode";
    let breadCrumb = [
        { label: i18n.t('pages.user.users'), url: "/User/List" },
        { label: i18n.t('pages.user.userList'), url: "/User/List" },
    ]
     let fields = [ 
         { key: 'username', label: i18n.t('user.list.username'), keys:['username'] },
         { key: 'firstname', label: i18n.t('user.list.name'), keys:['firstname']},
         { key: 'lastname', label: i18n.t('user.list.lastname'), keys:['lastname'] },
         { key: 'phoneno', label: i18n.t('user.list.phone'), keys:['phoneno'] },
         { key: 'email', label: i18n.t('user.list.email'), keys:['email'] },
         { key: 'active', label: i18n.t('user.list.status'), keys:['active'] },
         { key: 'actions', label: i18n.t('user.list.actions'), keys:['username'] }        
    ]; 

    let actions = [
        {key: 'active', text: i18n.t('user.list.activeAction'), state: true},
        {key: 'passive', text: i18n.t('user.list.passiveAction'), state: false},
        {key: 'delete', text: i18n.t('user.list.deleteAction')}
    ]

    let filtered = ['username', "firstname", 'lastname', 'phoneno', 'email', 'active', 'actions']; 

    export default {
        name: 'UserList',
         created: async function(){
            await this.$store.dispatch('user_list', {limit: this.limit, offset: this.offset})
            console.log(jwt_decode(localStorage.getItem('access_token')))
        },
        computed:{
            fetchData(){
                this.$store.dispatch('user_list', {limit: this.limit, offset: this.offset})
            },
            message(){
                return this.$store.getters.getCompanyStatus
            },
            loading(){
                return this.$store.getters.getLoading
            },
            list(){
                return this.$store.getters.getUsers
            },
            pageInfo(){
                return this.$store.getters.getUserPageInfo
            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, limit:10, page: 1, offset: 0, actions, modalOpen: false,
                modalProps: {}, currentForm:"User", modalName: "", dismissCountDown: 0
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        methods:{
            goDetail(item){
                this.$router.push( { path: '/User/'+item.id+'/edit' })
            },
            complete(){
                this.dismissCountDown = 5
                this.$store.dispatch('user_list', {limit: this.limit, offset: this.offset})
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            setLimit:function(limit){
                this.limit = limit
                this.$store.dispatch('user_list', {limit: this.limit, offset: this.offset})
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                    this.$store.dispatch('user_list', {limit: this.limit, offset: this.offset})
                }
            },
            actionEvent: async function(key, data){
                switch(key){
                     case 'active':
                        this.openModal(true, 'SetState', {user: data, state:true})
                        break;
                    case 'passive': 
                        this.openModal(true, 'SetState', {user: data, state:false})
                        break;
                    case 'delete':
                        this.openModal(true, 'delete', data)
                        break;
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/List.vue